import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.is-array.js";
import { Button, Dialog, Flex, Markdown, Notice, ProgressIndicator, Text } from '@applyboard/crystal-ui';
import { CheckMarkOutlineIcon, CircleCrossHifiIcon, CloseOutlineIcon } from '@applyboard/ui-icons';
import { useTranslation } from '@applyboard/ui-utils';
import { isFieldComponent } from "../../../../../components/DynamicForm";
import { assert } from "../../../../../utils/assert";
import { useApplicationRequirements } from "../../../data/applicationRequirements";
import { canBeEvaluated } from "../RequirementList.utils";
import { useRequirementListEventTracker } from "../../../utils/eventTracking";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
export function DecisionConfirmationDialog(_ref) {
  var _requirement$response, _requirement$response2, _requirement$response3, _requirement$response4, _requirement$availabl, _requirement$availabl2, _requirement$response5, _requirement$response6, _requirement$response7;
  var isEvaluationPending = _ref.isEvaluationPending,
    isSendingAction = _ref.isSendingAction,
    onClose = _ref.onClose,
    onSendAction = _ref.onSendAction,
    requirementId = _ref.requirementId,
    selectedAction = _ref.selectedAction;
  var _useTranslation = useTranslation('ApplicationRequirementCard'),
    t = _useTranslation.t;
  var _useRequirementListEv = useRequirementListEventTracker(),
    trackEvent = _useRequirementListEv.trackEvent;
  var _useApplicationRequir = useApplicationRequirements(),
    applicationRequirements = _useApplicationRequir.applicationRequirements;
  var requirement = applicationRequirements.find(function (requirement) {
    return requirement.id === requirementId;
  });
  assert(requirement, 'Requirement not found');
  var isApplicantRequirement = requirement.classification === 'applicant_requirement';
  var cantApproveInCurrentState = canBeEvaluated(requirement) && selectedAction === 'approve' && ((_requirement$response = requirement.responses) === null || _requirement$response === void 0 ? void 0 : (_requirement$response2 = _requirement$response.answersHistory) === null || _requirement$response2 === void 0 ? void 0 : _requirement$response2[0].answers.every(function (answer) {
    return answer.decisions.length && answer.decisions.every(function (decision) {
      return decision.status === 'rejected';
    });
  }));
  var cantRejectInCurrentState = canBeEvaluated(requirement) && selectedAction === 'reject' && ((_requirement$response3 = requirement.responses) === null || _requirement$response3 === void 0 ? void 0 : (_requirement$response4 = _requirement$response3.answersHistory) === null || _requirement$response4 === void 0 ? void 0 : _requirement$response4[0].answers.every(function (answer) {
    return answer.decisions.length && answer.decisions.every(function (decision) {
      return decision.status === 'approved';
    });
  }));
  var undoSubmitAction = (_requirement$availabl = requirement.availableActions) === null || _requirement$availabl === void 0 ? void 0 : _requirement$availabl.find(function (action) {
    return action.id === 'undo_submit';
  });
  var missingUndoSubmitAction = !undoSubmitAction && selectedAction === 'undo_submit';
  var cantUndoSubmitInCurrentState = undoSubmitAction && selectedAction === 'undo_submit' && ((_requirement$availabl2 = requirement.availableActions) === null || _requirement$availabl2 === void 0 ? void 0 : _requirement$availabl2.some(function (action) {
    var _action$additionalInf;
    return action.id === 'undo_submit' && ((_action$additionalInf = action.additionalInformation) === null || _action$additionalInf === void 0 ? void 0 : _action$additionalInf.blockedReason) === 'evaluating_requirement';
  }));
  var invalidAction = isApplicantRequirement && (!!cantApproveInCurrentState || !!cantRejectInCurrentState || cantUndoSubmitInCurrentState);
  var hasDraftSubmission = isApplicantRequirement && !(requirement !== null && requirement !== void 0 && (_requirement$response5 = requirement.responses) !== null && _requirement$response5 !== void 0 && (_requirement$response6 = _requirement$response5.answersHistory) !== null && _requirement$response6 !== void 0 && (_requirement$response7 = _requirement$response6[0]) !== null && _requirement$response7 !== void 0 && _requirement$response7.submitted) && requirement.formDefinition.components.some(isFieldComponent);
  var showErrorTitle = hasDraftSubmission || invalidAction;
  if (!selectedAction) {
    return null;
  }
  if (isEvaluationPending) {
    return _jsx(PendingEvaluationDialog, {
      isOpen: isEvaluationPending,
      onOpenChange: function onOpenChange(newOpen) {
        if (!newOpen) {
          onClose();
        }
      }
    });
  }
  if (missingUndoSubmitAction) {
    return _jsx(MissingUndoSubmitDialog, {
      isOpen: missingUndoSubmitAction,
      onOpenChange: function onOpenChange(newOpen) {
        if (!newOpen) {
          onClose();
        }
      }
    });
  }
  return _jsxs(Dialog, {
    open: !!selectedAction,
    onOpenChange: function onOpenChange(newOpen) {
      if (!newOpen) {
        if (selectedAction === 'reject') {
          trackEvent({
            event: 'Review - Make decision - Reject requirement modal - Cancelled reject requirement'
          });
        }
        onClose();
      }
    },
    children: [_jsx(Dialog.Heading, {
      children: showErrorTitle ? t("".concat(selectedAction, ".errorTitle")) : t("".concat(selectedAction, ".title"))
    }), _jsx(Dialog.Content, {
      children: _jsxs(Flex, {
        gap: 4,
        children: [invalidAction && _jsx(CircleCrossHifiIcon, {
          intent: "negative"
        }), _jsxs(Flex, {
          direction: "column",
          gap: 4,
          children: [hasDraftSubmission && _jsx(Notice, {
            intent: "negative",
            children: t('draftSubmissionNotice')
          }), _jsx(Markdown, {
            headingSettings: {
              baseLevel: 3
            },
            markdown: invalidAction ? t("".concat(selectedAction, ".errorContent"), {
              requirementTitle: requirement.title
            }) : isApplicantRequirement ? t("".concat(selectedAction, ".content"), {
              requirementTitle: requirement.title
            }) : t("".concat(selectedAction, ".contentAdmin"), {
              requirementTitle: requirement.title
            })
          })]
        })]
      })
    }), _jsx(Dialog.Actions, {
      children: invalidAction ? _jsx(Flex, {
        justify: "end",
        basis: "100%",
        children: _jsx(Dialog.CloseButton, {
          intent: "primary",
          emphasis: "contained",
          children: t('okay')
        })
      }) : _jsxs(_Fragment, {
        children: [_jsx(Dialog.CloseButton, {
          width: "fill",
          children: t('cancel')
        }), !hasDraftSubmission && _jsx(Button, {
          intent: selectedAction === 'reject' ? 'negative' : 'primary',
          leadIcon: selectedAction === 'approve' ? CheckMarkOutlineIcon : CloseOutlineIcon,
          emphasis: selectedAction === 'approve' ? 'contained' : 'outlined',
          width: "fill",
          loading: isSendingAction,
          onClick: function onClick() {
            return onSendAction(selectedAction);
          },
          children: t("".concat(selectedAction, ".button"))
        })]
      })
    })]
  });
}
export function isEvaluationComplete(requirement) {
  var _requirement$response11, _requirement$response12;
  if (requirement.classification !== 'applicant_requirement') {
    var _requirement$response8, _requirement$response9, _requirement$response10;
    return !!(requirement !== null && requirement !== void 0 && (_requirement$response8 = requirement.responses) !== null && _requirement$response8 !== void 0 && (_requirement$response9 = _requirement$response8.answersHistory) !== null && _requirement$response9 !== void 0 && (_requirement$response10 = _requirement$response9[0]) !== null && _requirement$response10 !== void 0 && _requirement$response10.submitted);
  }
  return requirement === null || requirement === void 0 ? void 0 : (_requirement$response11 = requirement.responses) === null || _requirement$response11 === void 0 ? void 0 : (_requirement$response12 = _requirement$response11.answersHistory) === null || _requirement$response12 === void 0 ? void 0 : _requirement$response12[0].answers.every(function (answer) {
    if (Array.isArray(answer.value)) {
      return answer.decisions.length && (answer.decisions.some(function (decision) {
        return decision.type === 'overall';
      }) || answer.decisions.length === answer.value.length);
    }
    return !!answer.decisions.length;
  });
}
function PendingEvaluationDialog(_ref2) {
  var isOpen = _ref2.isOpen,
    onOpenChange = _ref2.onOpenChange;
  var _useTranslation2 = useTranslation('ApplicationRequirementCard'),
    t = _useTranslation2.t;
  return _jsxs(Dialog, {
    open: isOpen,
    onOpenChange: onOpenChange,
    children: [_jsx(Dialog.Heading, {
      children: t('evaluationInProgress.title')
    }), _jsx(Dialog.Content, {
      children: _jsxs(Flex, {
        gap: 4,
        children: [_jsx(ProgressIndicator, {
          indeterminate: true,
          size: "lg",
          variant: "circular",
          "aria-label": t('evaluationInProgress.title')
        }), _jsx(Text, {
          children: t('evaluationInProgress.info')
        })]
      })
    })]
  });
}
function MissingUndoSubmitDialog(_ref3) {
  var isOpen = _ref3.isOpen,
    onOpenChange = _ref3.onOpenChange;
  var _useTranslation3 = useTranslation('ApplicationRequirementCard'),
    t = _useTranslation3.t;
  return _jsxs(Dialog, {
    open: isOpen,
    onOpenChange: onOpenChange,
    children: [_jsx(Dialog.Heading, {
      children: t('undo_submit.errorTitle')
    }), _jsx(Dialog.Content, {
      children: _jsx(Notice, {
        intent: "secondary",
        children: t('undo_submit.missingAction')
      })
    })]
  });
}